import React from "react";
import "./PlanetText.style.css";

const PlanetText = (props) => {
    return (
        <div
            className="planetText"
            style={props.isExploreButtonClicked ? { color: "white" } : { color: "transparent" }}
        >
            {props.content}
        </div>
    );
};

export default PlanetText;
